import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import classNames from 'classnames';
import { FormattedDate, FormattedMessage } from 'react-intl';
import CloseIcon from 'dibs-vg/dist/react/close';
import PenIcon from 'dibs-vg/dist/react/pen';

import { tabs } from '../../constants';

import styles from './ProjectRow.scss';

const messages = {
    unspecifiedAttribute: (
        <FormattedMessage
            id="favoritesNode.ProjectRow.unspecifiedAttribute"
            defaultMessage="(unspecified)"
        />
    ),
};

export default class ProjectRow extends React.Component {
    constructor(props) {
        super(props);

        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.onMouseOver = this.onMouseOver.bind(this);

        this.state = {
            inEditMode: false,
        };
    }

    onMouseLeave() {
        this.setState({ inEditMode: false });
    }

    onMouseOver() {
        this.setState({ inEditMode: true });
    }

    render() {
        const {
            forceEditMode,
            installDate,
            goToProjectPage,
            name,
            onDeleteClick,
            onEditAddressClick,
            onEditDateClick,
            onEditNameClick,
            portfolio,
            serviceId,
            shippingAddress = {},
        } = this.props;

        const showEditIcons = this.state.inEditMode || forceEditMode;

        const items = get(portfolio, 'items.edges') || [];
        const itemCount = items.length;
        const formattedItemCount = itemCount === 1 ? `${itemCount} item` : `${itemCount} items`;
        const formattedAddress = get(shippingAddress, 'formattedAddress') || [];
        const portfolioId = get(portfolio, 'serviceId');

        let addressNode;
        if (formattedAddress[0] || formattedAddress[1]) {
            addressNode = [
                <div key="addressPart1" data-tn="address-1">
                    {formattedAddress[0]}
                </div>,
                <div key="addressPart2" data-tn="address-2">
                    {formattedAddress[1]}
                </div>,
            ];
        } else {
            addressNode = (
                <div className={styles.attributeValue} data-tn="address-unspecified">
                    {messages.unspecifiedAttribute}
                </div>
            );
        }

        const installDateObj = installDate ? new Date(installDate) : null;

        const containerClass = classNames(styles.projectRowContainer, {
            [styles.editMode]: this.state.inEditMode,
        });

        return (
            <div
                className={containerClass}
                data-tn="project-list-item"
                onMouseLeave={this.onMouseLeave}
                onMouseOver={this.onMouseOver}
                ref="container"
            >
                <div className={styles.name}>
                    {showEditIcons && (
                        <div
                            className={styles.editName}
                            onClick={onEditNameClick}
                            data-tn="edit-project-name"
                        >
                            <PenIcon className={styles.editIcon} />
                        </div>
                    )}
                    <a
                        className={styles.projectLink}
                        data-tn="project-link"
                        href={`/favorites/${tabs.PROJECT}/${serviceId}/${portfolioId}/`}
                        onClick={goToProjectPage}
                    >
                        {name}
                    </a>
                    <div className={styles.itemCount}>{formattedItemCount}</div>
                </div>
                <div className={styles.installDate}>
                    {showEditIcons && (
                        <div
                            className={styles.editAttribute}
                            onClick={onEditDateClick}
                            data-tn="edit-project-install-date"
                        >
                            <PenIcon className={styles.editIcon} />
                        </div>
                    )}
                    <div className={styles.category}>
                        <FormattedMessage
                            id="favoritesNode.ProjectRow.fieldInstallDate"
                            defaultMessage="Install Date"
                        />
                    </div>
                    <div className={styles.attributeValue} data-tn="install-date">
                        {!!installDateObj && !isNaN(installDateObj.getYear()) ? (
                            <FormattedDate
                                value={installDateObj}
                                year="numeric"
                                month="numeric"
                                day="2-digit"
                            />
                        ) : (
                            messages.unspecifiedAttribute
                        )}
                    </div>
                </div>
                <div className={styles.shippingAddress}>
                    {showEditIcons && (
                        <div
                            className={styles.editAttribute}
                            onClick={onEditAddressClick}
                            data-tn="edit-project-shipping-address"
                        >
                            <PenIcon className={styles.editIcon} />
                        </div>
                    )}
                    <div className={styles.category}>
                        <FormattedMessage
                            id="favoritesNode.ProjectRow.fieldShippingAddress"
                            defaultMessage="Shipping Address"
                        />
                    </div>
                    <div className={styles.attributeValue}>{addressNode}</div>
                </div>
                {showEditIcons && (
                    <div className={styles.deleteIconContainer} onClick={onDeleteClick}>
                        <CloseIcon className={styles.deleteIcon} />
                    </div>
                )}
            </div>
        );
    }
}

ProjectRow.propTypes = {
    forceEditMode: PropTypes.bool,
    installDate: PropTypes.string,
    goToProjectPage: PropTypes.func.isRequired,
    name: PropTypes.string,
    onDeleteClick: PropTypes.func.isRequired,
    onEditAddressClick: PropTypes.func.isRequired,
    onEditDateClick: PropTypes.func.isRequired,
    onEditNameClick: PropTypes.func.isRequired,
    portfolio: PropTypes.object.isRequired,
    serviceId: PropTypes.string.isRequired,
    shippingAddress: PropTypes.object,
};
